// extracted by mini-css-extract-plugin
export default {"loader":"koQ2wYjBPTCE9YMrY2vX","circular":"h7DKiwxMD_2xQq8fllAD","rotate":"NTlDtpFx_vRPE4pQ2hoe","path":"J9Hh_2UklOe9xWilL_xw","dash":"oKCzpfX6Kexy9ID0xMa8"};